import React from 'react';
import CircularProgressbar from './CircularProgressbar';
import {motion, AnimatePresence} from 'framer-motion';

const Skill = ({rate, name, src}) => {
    return (
            <div
            className=' aspect-square relative m-2 p-2'
            >
                <CircularProgressbar percentage={rate} size={150} colour="#F5F5F5" className="absolute"/>
                <div className='absolute top-[50%] left-[50%] translate-y-[-50%] translate-x-[-50%] w-[70px] aspect-square group'>
                    <div className='absolute inset-0 w-full aspect-square flex justify-center items-center opacity-0 group-hover:blur-sm group-hover:opacity-100'><img src={src} alt="" className='w-[70px] h-[70px] p-1 object-contain'></img></div>
                    <div className='absolute inset-0 w-full aspect-square flex justify-center items-center opacity-50 group-hover:opacity-100'><img src={src} alt="" className='w-[70px] h-[70px] p-1 object-contain'></img></div>
                </div>
                <div className='absolute inset-x-0 bottom-0 w-full translate-y-[10px] text-center text-white'>{name}</div>
            </div>
    );
};

export default Skill;
